import { PayrollExportMapping } from '@pxtra-client-lib-legacy/gen';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { useStore } from '../../../../../hooks/useStore';
import { PayrollExportMappingTable } from './table';
import { Box } from '@mui/material';
import { useCompanySettings } from '../../../../../queries/company';

type MappingProps = {
  onDataChange?: (data: PayrollExportMapping) => void;
};

export const processingKeyList = ['1', '2'];

export const PayrollMappingEdit: FC<MappingProps> = observer(({ onDataChange }) => {
  const { companyStore } = useStore();
  const companyId = companyStore.company?.id ?? 'MISSING_ID';

  const { data: companySettings } = useCompanySettings(companyStore.company?.id ?? '');
  const selectedPayrollSystem = companySettings?.payroll_system ?? 'OTHER';

  return (
    <Box display="flex" flexDirection="column">
      <PayrollExportMappingTable
        company={companyId}
        system={selectedPayrollSystem}
        isCellEditable={true}
        onChange={(data) => {
          onDataChange?.(data);
        }}
      />
    </Box>
  );
});
